import React from 'react'
import _ from 'lodash'
import { Row } from 'antd'
import { P } from 'konsys-ui'
import contents from './detail/contents'
import ComponentRenderer from './detail/component-renderer'
import { Wrapper } from '../../components/job-components'
import { detailMode } from './constants'
import history from '../../history'

const RowRenderer = ({
  data, mode, onChangeHandler, client, jobInfo, mutationVariables, loadingLastPrice,
}) => data.map(v => <ComponentRenderer key={v.id} data={v} mode={mode} onChangeHandler={onChangeHandler} client={client} jobInfo={jobInfo} mutationVariables={mutationVariables} loadingLastPrice={loadingLastPrice}/>)

const DetailModeHandler = (params, onChangeHandler, client, mutationVariables, loadingLastPrice, jobInfo) => {
  const mode = params.mode.toUpperCase()
  switch (mode) {
    case detailMode.ADD:
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row align='flex-start' type='flex' gutter={12}>
            <RowRenderer mutationVariables={mutationVariables} data={v} mode={mode} onChangeHandler={(id, value) => onChangeHandler(id, value)} client={client} jobInfo={jobInfo}/>
            {/* jobInfo = loadingLastPrice */}
          </Row>
        </Wrapper>
      ))
    case detailMode.EDIT:
    case detailMode.VIEW:
    {
      if (_.isUndefined(params.id)) history.push('/job')
      // mockup data
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row align='flex-start' type='flex' gutter={12}>
            <RowRenderer mutationVariables={mutationVariables} data={v} mode={mode} onChangeHandler={(id, value) => onChangeHandler(id, value)} client={client} jobInfo={jobInfo} loadingLastPrice={loadingLastPrice}/>
          </Row>
        </Wrapper>
      ))
    }
    default:
      return <P>Something went wrong!</P>
  }
}

export default DetailModeHandler
